<label [ngClass]="{ required: required }" [for]="for"
  ><span class="p-r">{{ label }}</span
  ><span
    *ngIf="tooltip"
    class="pi pi-exclamation-circle tooltip-icon p-r"
    [pTooltip]="tooltip"
    tooltipStyleClass="tp2-tooltip tp2-tooltip-right"
  ></span
></label>
